import { Typography } from "@connected-repo/ui-mui/data-display/Typography";
import { Button } from "@connected-repo/ui-mui/form/Button";
import { Box } from "@connected-repo/ui-mui/layout/Box";
import { Container } from "@connected-repo/ui-mui/layout/Container";
import { Stack } from "@connected-repo/ui-mui/layout/Stack";
import { AppBar } from "@connected-repo/ui-mui/navigation/AppBar";
import { Toolbar } from "@connected-repo/ui-mui/navigation/Toolbar";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import RecordVoiceOverOutlinedIcon from "@mui/icons-material/RecordVoiceOverOutlined";
import type { AdminSession } from "@superadmin/utils/admin.loader";
import { authClient } from "@superadmin/utils/auth.client";
import { Outlet, useLoaderData, useLocation, useNavigate } from "react-router";

const NAV = [
	{ label: "Teams", path: "/teams", icon: <GroupsOutlinedIcon fontSize="small" /> },
	{ label: "Feature flags", path: "/flags", icon: <FlagOutlinedIcon fontSize="small" /> },
	{ label: "Voices", path: "/voices", icon: <RecordVoiceOverOutlinedIcon fontSize="small" /> },
];

export const AdminLayout = () => {
	const { user } = useLoaderData() as AdminSession;
	const navigate = useNavigate();
	const location = useLocation();

	const signOut = async () => {
		await authClient.signOut();
		window.location.href = "/login";
	};

	return (
		<Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
			<AppBar
				position="sticky"
				elevation={0}
				sx={{ bgcolor: "background.paper", borderBottom: "1px solid", borderColor: "divider" }}
			>
				<Toolbar sx={{ gap: 2 }}>
					<Stack
						direction="row"
						alignItems="center"
						spacing={1}
						onClick={() => navigate("/teams")}
						sx={{ cursor: "pointer" }}
					>
						<Box component="img" src="/brand/conferhall-mark.svg" alt="" sx={{ width: 28, height: 28 }} />
						<Typography
							variant="h6"
							sx={{ fontWeight: 800, color: "primary.main", letterSpacing: -0.5 }}
						>
							ConferHall Admin
						</Typography>
					</Stack>
					<Stack direction="row" spacing={0.5} sx={{ flexGrow: 1, ml: 2 }}>
						{NAV.map((item) => {
							const active = location.pathname.startsWith(item.path);
							return (
								<Button
									key={item.path}
									startIcon={item.icon}
									onClick={() => navigate(item.path)}
									sx={{
										borderRadius: 2,
										color: active ? "primary.main" : "text.secondary",
										bgcolor: active ? "primary.lighter" : "transparent",
										fontWeight: active ? 600 : 500,
									}}
								>
									{item.label}
								</Button>
							);
						})}
					</Stack>
					<Typography variant="body2" color="text.secondary" sx={{ display: { xs: "none", sm: "block" } }}>
						{user.email ?? user.name}
					</Typography>
					<Button startIcon={<LogoutIcon />} onClick={() => void signOut()} color="inherit">
						Sign out
					</Button>
				</Toolbar>
			</AppBar>
			<Container maxWidth="lg" sx={{ py: { xs: 2, md: 4 } }}>
				<Outlet context={{ user }} />
			</Container>
		</Box>
	);
};
